<template>
  <div class="home">
    <common-header></common-header>
    <img src="../img/m/progress.png" alt="" class="progress">
    <div class="page_content">
      <div class="content_nav">
        <span :class="['nav_item', resource == 1 ? 'active_item' : '']" @click="changeResource(1)">
          <span class="cn_name">短视频</span>
          <span class="en_name">VLOG</span>
        </span>
        <span :class="['nav_item', resource == 2 ? 'active_item' : '']" @click="changeResource(2)">
          <span class="cn_name">图片故事</span>
          <span class="en_name">PLOG</span>
        </span>
      </div>
      <div class="search_con clearfix">
        <div class="input_con">
          <img src="../img/m/search.png" alt="" class="search_img" @click="searchFun()">
          <input type="text" v-model="keyword" @keyup.enter="searchFun()">
          <div class="search_type" @click="showSearchPicker = true">
            <span>{{searchList.find(v => search_type == v.id).name}}</span>
            <img src="../img/m/searchTypeTriangle.png" alt="">
          </div>
        </div>
        <van-popup v-model="showSearchPicker" position="bottom">
          <van-picker
            show-toolbar
            value-key='name'
            :columns="searchList"
            @confirm="onConfirmSearch"
            @cancel="showSearchPicker = false"
          />
        </van-popup>
        <div class="filter_con" @click="showFilterPicker = true">
          <span>筛选</span>
          <img src="../img/m/filter.png" alt="">
        </div>
      </div>
      <ul class="works_list">
        <li v-for="(v, i) in dataList" :key="i" @click="goDetail(v)">
          <div class="cover_con">
            <img :src="'https://collection2021-cos.chineseplus.net/'+v[resource == 1 ? 'video_cover' : 'cover']" alt="" class="cover_img">
            <img src="../img/m/video_btn.png" alt="" class="video_btn" v-show="resource == 1">
            <div class="zan_con">
              <img src="../img/m/zan.png" alt="">
              <span class="num">{{v.like_num}}</span>
            </div>
          </div>
          <div class="work_name">{{v.title}}</div>
          <div class="author">提供者：{{v.user_name}}</div>
          <div class="country">所在国：{{v.cn}}</div>
        </li>
      </ul>
      <div class="more" @click="getMore()" v-show="showMore">更多     MORE</div>
    </div>
    <van-popup v-model="showFilterPicker" position="bottom">
      <div class="filter_wrap">
        <div class="top">
          全部筛选
          <img src="../img/m/×.png" alt="" class="close" @click="showFilterPicker = false">
        </div>
        <div class="type_con">
          <div class="type_name">作品分类</div>
          <ul class="type_list clearfix">
            <li v-for="(v, i) in categoryList" :key="i" :class="{active: v.category_id == category_id}" @click="getTopicList(v)">{{v.category_name}}</li>
          </ul>
        </div>
        <div class="type_con">
          <div class="type_name">作品话题</div>
          <ul class="type_list clearfix">
            <li v-for="(v, i) in topicList" :key="i" :class="{active: v.topic_id == topic_id}" @click="getTopic(v)">{{v.topic_name}}</li>
          </ul>
        </div>
      </div>
      <div class="finishFilter" @click="filterFun()">
        完成
      </div>
    </van-popup>
    <common-footer></common-footer>
  </div>
</template>

<script>
import { Notify } from 'vant'
import commonHeader from './common/commonHeader'
import commonFooter from './common/commonFooter'

export default {
  components: {
    commonHeader,
    commonFooter
  },
  data () {
    return {
      showSearchPicker: false,
      searchList: [
        {
          id: 1,
          name: '作品名'
        },
        {
          id: 2,
          name: '用户名'
        }
      ],
      dataList: [],
      showFilterPicker: false,
      categoryList: [],
      topicList: [],
      resource: 1,
      sort: 1,
      page: 1,
      search_type: 1,
      category_id: null,
      topic_id: null,
      keyword: '',
      showMore: true
    }
  },
  created () {
    this.resource = this.$route.query.resource || 1
    this.getList()
    this.getCategoryList()
  },
  methods: {
    // 分类picker
    onConfirmSearch (value) {
      this.search_type = value.id
      this.showSearchPicker = false
    },
    getCategoryList () {
      this.$utils.get('/works/getCategory').then(res => {
        this.categoryList = res.data
      })
    },
    getTopicList (v) {
      this.category_id = v.category_id
      this.topic_id = undefined
      this.$utils.get('/works/getTopic', {category_id: this.category_id}).then(res => {
        this.topicList = res.data
      })
    },
    getTopic (v) {
      this.topic_id = v.topic_id
    },
    changeResource (item) {
      this.resource = item
      this.page = 1
      this.dataList = []
      this.getList()
      this.$router.push({
        path: '/mpage/m_gallery',
        query: {
          resource: this.resource
        }
      })
    },
    searchFun () {
      this.page = 1
      this.dataList = []
      this.getList()
    },
    filterFun () {
      this.page = 1
      this.dataList = []
      this.showFilterPicker = false
      this.getList()
    },
    getMore () {
      this.page++
      this.getList()
    },
    getList () {
      let param = {
        type: this.resource,
        pageSize: 10,
        page: this.page,
        keyword: this.keyword,
        search_type: this.search_type,
        category_id: this.category_id,
        topic_id: this.topic_id
      }
      if (!this.keyword) delete param.search_type

      this.$utils.get('/works/list', param).then(res => {
        if(res.code == 1000) {
          this.showMore = true
          if (!res.data.list.length) {
            Notify({ type: 'warning', message: '暂无更多数据' })
            this.showMore = false
          }
          this.dataList.push(...res.data.list)
        } else {
          Notify({ type: 'warning', message: res.msg })
        }
      })
    },
    goDetail (v) {
      this.$router.push({
        path: this.resource == 1 ? 'm_videoworksInfo' : '/mpage/m_picworksInfo',
        query: {
          id: v.works_id
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.home {
  width: 100%;
  margin: 0 auto 0;
  text-align: center;
  font-size: 20px;
  text-align: left;
  .progress {
    width: 13.43rem;
    height: 1.26rem;
    display: block;
    margin: auto;
    margin-top: .6rem;
  }
  .page_content {
    background: #fff;
    box-sizing: border-box;
    width: calc(100% - .9rem);
    margin: auto;
    margin-top: .6rem;
    position: relative;
    padding: .62rem .37rem .38rem .37rem;
    min-height: 12.85rem;
    .content_nav {
      color: #818181;
      text-align: center;
      margin-bottom: .62rem;
      .nav_item {
        display: inline-block;
        &:nth-child(1) {
          margin-right: 1.3rem;
        }
        &.active_item {
          color: #9576ef;
          .cn_name {
            font-weight: bold;
          }
        }
        .cn_name {
          font-size: .8rem;
          margin-right: .1rem;
          // font-weight: bold;
        }
        .en_name {
          font-size: .45rem;
          // font-weight: bold;
          // opacity: 0.6;
        }
      }
    }
    .search_con {
      margin-bottom: .6rem;
      .input_con {
        position: relative;
        float: left;
        .search_img {
          width: .62rem;
          position: absolute;
          left: .3rem;
          top: .3rem;
        }
        .search_type {
          position: absolute;
          right: .3rem;
          top: .3rem;
          font-size: .48rem;
          color: #9576ef;
          span {
            vertical-align: middle;
            margin-right: .25rem;
          }
          img {
            width: .45rem;
            vertical-align: middle;
          }
        }
        input {
          width: 10.94rem;
          height: 1.16rem;
          border: solid .01rem #9576ef;
          padding: .1rem 0;
          padding-left: 1rem;
          padding-right: 2.5rem;
          box-sizing: border-box;
          font-size: .48rem;
        }
      }
      .filter_con {
        font-size: .48rem;
        color: #282828;
        float: right;
        margin-top: .3rem;
        img {
          width: .5rem;
          margin-left: .1rem;
        }
      }
    }
    .sort_con {
      font-size: .52rem;
      color: #303030;
      margin-bottom: .6rem;
      span {
        margin-right: 1.85rem;
        &.active_sort {
          color: #9576ef;
        }
      }
    }
    .works_list {
      li {
        margin-bottom: .4rem;
        display: inline-block;
        &:nth-child(odd) {
          margin-right: .3rem;
        }
        .cover_con {
          width: 6.23rem;
	        height: 3.9rem;
          position: relative;
          .cover_img {
            width: 100%;
            height: 100%;
            display: block;
          }
          .video_btn {
            position: absolute;
            left: .52rem;
            bottom: .52rem;
            width: .95rem;
          }
          .zan_con {
            position: absolute;
            right: .52rem;
            bottom: .5rem;
            img {
              width: .8rem;
              display: block;
            }
            .num {
              color: #fff;
              font-size: .6rem;
              font-weight: bold;
            }
          }
        }
        .work_name {
          font-size: .56rem;
          color: #212121;
          margin-top: .2rem;
          width: 6.23rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .author {
          color: #212121;
          font-size: .4rem;
          margin-top: .2rem;
        }
        .country {
          color: #212121;
          font-size: .4rem;
          margin-top: .15rem;
        }
      }
    }
    .more {
      height: 1.21rem;
      line-height: 1.21rem;
      background-color: #9576ef;
      text-align: center;
      color: #fff;
      font-size: .45rem;
      margin-top: .2rem;
    }
  }
  .filter_wrap {
    .top {
      position: relative;
      padding: .6rem .46rem;
      font-size: .6rem;
      color: #282828;
      text-align: center;
      .close {
        width: .54rem;
        position: absolute;
        right: .46rem;
        top: .6rem;
      }
    }
    .type_con {
      padding: 0 .46rem;
      margin-bottom: .7rem;
      .type_name {
        font-size: .6rem;
        color: #282828;
        margin-bottom: .3rem;
      }
      .type_list {
        font-size: .5rem;
        color: #282828;
        li {
          background-color: #f6f6f6;
          border-radius: .7rem;
          text-align: center;
          padding: 0 .74rem;
          height: 1.4rem;
          line-height: 1.38rem;
          float: left;
          margin-right: .29rem;
          margin-bottom: .3rem;
          &.active {
            background-color: #9576ef;
            color: #fff;
          }
        }
      }
    }
  }
  .finishFilter {
    background-color: #2f2f31;
    font-size: .8rem;
    color: #fff;
    text-align: center;
    line-height: 2.4rem;
  }
}
</style>